//导入两个文件
import en from './en';
import cn from './cn';
export default {
  en: en,
  cn: cn
}